export default __webpack_public_path__ + "static/media/checkmark.9baf4643.svg";